import * as React from "react"
import { type EntityTransaction } from "@digits-graphql/frontend/graphql-bearer"
import { LoadingBlock } from "@digits-shared/components/Loaders"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"
import dayjs from "@digits-shared/initializers/dayjs/dayjs"
import useIntervalOrigin from "src/shared/hooks/useIntervalOrigin"

const Year = styled.div`
  ${fonts.scale.label};
`

export const DateCell: React.FC<{ transaction: EntityTransaction }> = ({ transaction }) => {
  const { year } = useIntervalOrigin()
  const date = dayjs.unix(transaction.timestamp).utc()
  if (date.year() === year) {
    return <b>{dayjs.unix(transaction.timestamp).utc().format("MMM DD")}</b>
  }

  return (
    <>
      <b>{date.format("MMM DD")}</b>
      <Year>{date.format("YYYY")}</Year>
    </>
  )
}

export const LoadingDateCell: React.FC = () => <LoadingBlock width="100%" height="20px" />
